import { Badge } from '@/shared/components/ui/badge';
import { Button } from '@/shared/components/ui/button';
import { TrendingUp } from 'lucide-react';
import CareerStats from '@/modules/Career/components/career/CareerStats';
import { careerStats } from '@/modules/Career/Data/careerData';

interface CareerHeroProps {
  onSignIn?: () => void;
  showSignInButton?: boolean;
}

export default function CareerHero({ onSignIn, showSignInButton = false }: CareerHeroProps) {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-transparent to-indigo-600/10" />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="text-center">
          <Badge variant="secondary" className="mb-4 px-3 py-1">
            <TrendingUp className="mr-1 h-3 w-3" />
            AI-Powered Recruitment
          </Badge>
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
            <span className="gradient-text block">Build Your Career</span>
            <span className="block text-slate-700">with Viraaj Ventures</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg text-slate-600">
            Join our family of companies spanning Real Estate, Marketing, Engineering, and Digital
            Solutions. Experience AI-powered hiring that values your potential.
          </p>

          <section className="bg-slate-50/50 ">
            <div className="max-w-7xl px-4 sm:px-6 lg:px-8">
              <CareerStats stats={careerStats} />
            </div>
          </section>
          {showSignInButton && onSignIn && (
            <div className="mt-10 flex items-center justify-center gap-4">
              <Button size="lg" onClick={onSignIn}>
                Sign In
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
